import { FC } from "react";
import classNames from "classnames";

import Skeleton from "../../../../components/Skeleton/Skeleton";
import tableStyles from "../../../../components/SourceTable/SourceTable.module.css";

import styles from "./SourceDomainsTableSkeleton.module.css";

const TABLE_ROWS = 10;
const COLUMN_COUNT = 7;

const SourceDomainsTableSkeleton: FC<{ className?: string }> = ({
  className,
}) => (
  <div
    className={classNames(styles["source_domains_skeleton"], className)}
    aria-busy="true"
    aria-label="Loading domains"
  >
    <table className={tableStyles["source_table"]}>
      <thead>
        <tr className={tableStyles["source_table__header_row"]}>
          <th>
            <Skeleton height={20} width={24} variant="text" />
          </th>
          <th>
            <Skeleton height={20} width={80} variant="text" />
          </th>
          <th>
            <Skeleton height={20} width={90} variant="text" />
          </th>
          <th>
            <Skeleton height={20} width={60} variant="text" />
          </th>
          <th>
            <Skeleton height={20} width={56} variant="text" />
          </th>
          <th>
            <Skeleton height={20} width={72} variant="text" />
          </th>
          <th aria-hidden>
            <Skeleton height={32} width={32} />
          </th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: TABLE_ROWS }).map((_, rowIndex) => (
          <tr
            key={rowIndex}
            className={tableStyles["source_table__body_row"]}
          >
            {Array.from({ length: COLUMN_COUNT }).map((_, colIndex) => (
              <td key={colIndex}>
                {colIndex === 0 ? (
                  <Skeleton height={24} width={20} variant="text" />
                ) : colIndex === 1 ? (
                  <div className={tableStyles["source_table__source"]}>
                    <Skeleton
                      width={28}
                      height={28}
                      className={tableStyles["source_table__logo"]}
                    />
                    <Skeleton height={20} width={140} variant="text" />
                  </div>
                ) : colIndex === COLUMN_COUNT - 1 ? (
                  <Skeleton height={32} width={32} />
                ) : (
                  <Skeleton height={24} width={48} variant="text" />
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SourceDomainsTableSkeleton;
